import { Component, forwardRef, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormInputComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormInputComponent implements ControlValueAccessor {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly translateService = inject(TranslateService);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value) {
        this._value = value;
        this._onChange(value);
        this._onTouched(value);
    }

    public get error() {
        return this._error;
    }

    @Input()
    public set error(value: string) {
        this._error = value;
        this.popoverDirective.popover = '';
        this.popoverDirective.placement = this.errorPosition;
        this.popoverDirective.hide();

        if (value) {
            this.popoverDirective.popover = this.translateService.instant(value);
            this.popoverDirective.show();
        }
    }

    @Input() type: string;
    @Input() placeholder: string;
    @Input() disable: boolean;
    @Input() readonly: boolean;
    @Input() searching: boolean;
    @Input() errorPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';

    @Output() changed = new EventEmitter();

    private _value: any;
    private _error: string;
    @ViewChild(PopoverDirective, { static: true }) private readonly popoverDirective: PopoverDirective;

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    writeValue(value: any): void {
        if (value !== null) {
            this.value = value;
            this.changeDetectorRef.markForCheck();
        }
    }

    onChange(newValue: any): void {
        this.changed.emit(newValue);
    }

    setDisabledState(isDisabled: boolean) {
        this.disable = isDisabled;
        this.changeDetectorRef.markForCheck();
    }

    private _onChange: any = () => {};
    private _onTouched: any = () => {};
}
